import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoggerModule, NgxLoggerLevel } from 'ngx-logger';
import { HttpClientModule } from '@angular/common/http';

import { LoggerService } from './logger.service';

@NgModule({
	declarations: [],
	imports: [
		CommonModule,
		HttpClientModule,
		LoggerModule.forRoot({
			level: NgxLoggerLevel.DEBUG
		})
	],
	providers: [LoggerService]
})
export class LoggerServiceModule {}
